/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Proyek_S2Inputs */

const en_tut_proyek_s2 = /** @type {(inputs: Tut_Proyek_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move issues into it from the **Proyek** field in the issue property panel, or while creating them.`)
};

const id_tut_proyek_s2 = /** @type {(inputs: Tut_Proyek_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pindahkan issue ke proyek lewat kolom **Proyek** di panel properti issue, atau saat membuatnya.`)
};

/**
* | output |
* | --- |
* | "Move issues into it from the **Proyek** field in the issue property panel, or while creating them." |
*
* @param {Tut_Proyek_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_proyek_s2 = /** @type {((inputs?: Tut_Proyek_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Proyek_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_proyek_s2(inputs)
	return en_tut_proyek_s2(inputs)
});